import { useMemo } from 'react';
import { doesExist } from 'utils/tsHelpers';
import { useCriteriaCombinatorFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';
import { Combinator } from '../../../types';

export const useHasCriteriaCombinatorError = (combinator: Combinator) => {
  const fieldPath = useCriteriaCombinatorFieldPath();
  const { getHasErrorFromFieldPath } = useQueryErrorStateContext();
  const errorFromFieldPath = getHasErrorFromFieldPath(fieldPath);

  return useMemo(() => {
    if (doesExist(combinator)) return false;
    else return errorFromFieldPath;
  }, [combinator, errorFromFieldPath]);
};
